import { memo, useEffect, useState, useLayoutEffect } from "react";
import { ViewName } from "../../components/Cards/templateCard/types";

import { useParams } from "react-router-dom";
import MainTemplate from "../../layout/MainLayout";

import Filters, { DefaultFilters } from "./components/Filters";
import Results from "./components/Results";
import ProjectMenu from "./components/ProjectMenu";
import Detail from "./components/Detail";
import { ProjectDetailType } from "./components/types";

// hooks 
import { useDetailProjectModel } from "./hooks/useDetailProjectModel";


const ProjectDetail = memo(() => {
  const { id = "" } = useParams();
  const [viewName, setViewName] = useState<ViewName>("List");
  const [sort, setSort] = useState<string>("asc");
  const [filters, setFilters] = useState<Record<string, string | number>>(DefaultFilters);
  
  // hooks
  const { detailProject, getDataDetailModel } = useDetailProjectModel();
  
  const isDepto = (detailProject as ProjectDetailType)?.type === "apto";

  useEffect(() => {
    getDataDetailModel(id);
  }, []);

  return (
    <MainTemplate>
      <div className="w-full">
        <div className="container mx-auto" >
          <div className="pt-20 pb-10 lg:pt-28">

            <ProjectMenu detailProject={detailProject as ProjectDetailType} />

            <Detail detailProject={detailProject as ProjectDetailType} />

            <Filters
              viewName={viewName}
              setViewName={setViewName}
              detailProject={detailProject as ProjectDetailType}
              sort={sort}
              setSort={setSort}
              setFilters={setFilters}
              isDepto={isDepto}
            />

            <Results
              viewName={viewName}
              detailProject={detailProject as ProjectDetailType}
              sort={sort}
              filters={filters}
              setFilters={setFilters}
              isDepto={isDepto}
            />

          </div>
        </div>
      </div>
    </MainTemplate>
  );
});

ProjectDetail.displayName = "ProjectDetail";
export default ProjectDetail;

/* 
  Modificaciones Daniel Bonilla
  - Modificado en su totalidad el componente para ajustarse a los nuevos requerimientos

  Octubre 2025
*/